// src/themes/theme/index.ts
import type { PalettesProps } from '@ant-design/colors';
import type { PaletteThemeProps } from 'types/theme';
// Keep the signature so callers don't break:
import type { PresetColor } from 'types/config';
import type { ThemeMode } from 'config';

import Default from './default';

// Always use Default; ignore presetColor/mode to simplify
export default function ThemeOption(
  colors: PalettesProps,
  _presetColor?: PresetColor,
  _mode?: ThemeMode
): PaletteThemeProps {
  return Default(colors);
}
